import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetByIdProfessionalManagementUseCaseInterface } from 'domain/usecases';

interface IProfessionalManagementByIdState {
  professionalManagementById: GetByIdProfessionalManagementUseCaseInterface.Result;
}

interface IPayloadProfessionalManagementById
  extends PayloadAction<GetByIdProfessionalManagementUseCaseInterface.Result> {}

const initialState: IProfessionalManagementByIdState = {
  professionalManagementById: null,
};

export const ProfessionalManagementByIdSlice = createSlice({
  name: 'professional-management-by-id',
  initialState,
  reducers: {
    loadProfessionalManagementById: (
      state,
      action: IPayloadProfessionalManagementById,
    ) => {
      state.professionalManagementById = action.payload;
    },
    clearProfessionalManagementById: (state) => {
      state.professionalManagementById = null;
    },
  },
});

export const {
  loadProfessionalManagementById,
  clearProfessionalManagementById,
} = ProfessionalManagementByIdSlice.actions;

export default ProfessionalManagementByIdSlice.reducer;
